import React from "react";
import { MusicHallRegisEquipmentProviderStyled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import { Buttons, Inputs } from "components";

const MusicHallRegisEquipmentProvider = ({
  initialValues,
  equipmentOptions,
  isDisabledForm,
  onBack,
  onSubmit,
}) => {
  const schema = yup.object().shape({
    additional_equipment_provider: yup.array().required("required"),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: initialValues,
  });
  const { t } = useTranslation(["common", "form", "room"]);

  return (
    <MusicHallRegisEquipmentProviderStyled>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="equipment_layout">
          <div className="equipment_text1">
            {t("Equipment Provided (Free of Charge)", { ns: "form" })}
          </div>
          <div className="equipment_text2">
            ({t("Select any standard equipment you need", { ns: "form" })})
          </div>
          <div className="checkbox_layout">
            <Controller
              control={control}
              render={({ field }) => (
                <Inputs.MultiCheckBox
                  {...field}
                  disabled={isDisabledForm}
                  options={
                    equipmentOptions

                    //   [
                    //   {
                    //     label:
                    //       "Grand Piano CFX (The piano can be moved to the side of the stage *but not off stage)",
                    //     value: "1",
                    //   },
                    //   {
                    //     label: "2 Wireless Microphones with 2 mic stands",
                    //     value: "2",
                    //   },
                    //   {
                    //     label:
                    //       "LED Screen on the stage (1 Still picture as jpeg file 2994 x 960 pixel)",
                    //     value: "3",
                    //   },
                    //   {
                    //     label:
                    //       "LED screen at reception area (1 Still picture as jpeg file 1920 x 1080 pixel)",
                    //     value: "4",
                    //   },
                    //   { label: "Table for registration (1 table)", value: "5" },
                    //   {
                    //     label:
                    //       "Speaker on stage (front of house on left and right side at a stage)",
                    //     value: "6",
                    //   },
                    //   { label: "120 chairs", value: "7" },
                    //   { label: "Podium", value: "8" },
                    //   { label: "Piano pedal extender", value: "9" },
                    //   {
                    //     label:
                    //       "Reserved VIP parking (for 5 cars) * Please provide the license plate numbers before the event",
                    //     value: "10",
                    //   },
                    // ]
                  }
                  // placeholder={t('test')}
                  errors={errors.additional_equipment_provider?.message}
                />
              )}
              name="additional_equipment_provider"
              defaultValue={[]}
            />
          </div>
        </div>
        <div className="button_layout">
          <div className="button1">
            <Buttons.BgStandard
              theme_white_purple
              label={t("Back", { ns: "common" })}
              onClick={onBack}
            />
          </div>
          <div className="button2">
            <Buttons.BgStandard
              theme_white_purple={isDisabledForm}
              label={t("Next", { ns: "common" })}
              type="submit"
            />
          </div>
        </div>
      </form>
    </MusicHallRegisEquipmentProviderStyled>
  );
};

MusicHallRegisEquipmentProvider.propTypes = {};

export default MusicHallRegisEquipmentProvider;
